import { DAYS, Holiday, validateHoliday, WEEKS } from 'apis/types';
import { LabeledReadOnlyInput, ReadOnlyInput } from 'components/Fields';

export default function Holidays(storeHolidayList: Holiday[], isMobile: boolean) {
  if (storeHolidayList.length == 0) return null;

  return [
    ...RegularHolidays(storeHolidayList, isMobile),
    ...SpecificHolidays(storeHolidayList, isMobile),
    ...MonthlyDateHolidays(storeHolidayList, isMobile),
  ];
}

const SpecificHolidays = (storeHolidayList: Holiday[], isMobile: boolean) => {
  return storeHolidayList
    .filter((v) => v.holidayType === 'SPECIFIC_DATE' && validateHoliday(v))
    .map((holiday, i) =>
      i === 0 ? (
        <div style={{ display: 'flex', gap: '8px', marginTop: 20 }} key={i}>
          <LabeledReadOnlyInput
            label="휴무일"
            value="임시 휴무일"
            isMobile={isMobile}
            style={{ width: 100 }}
            isColumn={true}
          />
          <LabeledReadOnlyInput
            label="시작일"
            value={`${holiday.specificDates[0][0]}년`}
            isMobile={isMobile}
            style={{ width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 80 }}
            isColumn={true}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates[0][1]}월`}
            style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 60 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates[0][2]}일`}
            style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 60 }}
          />
          <LabeledReadOnlyInput
            label="종료일"
            value={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][0] : holiday.specificDates[1][0]}년`}
            isMobile={isMobile}
            style={{ width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 80 }}
            isColumn={true}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][1] : holiday.specificDates[1][1]}월`}
            style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 60 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][2] : holiday.specificDates[1][2]}일`}
            style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 6) / 6)`, minWidth: 60 }}
          />
        </div>
      ) : (
        <div style={{ display: 'flex', gap: '8px', marginTop: 4 }} key={i}>
          <ReadOnlyInput text="임시 휴무일" style={{ width: 100 }} />
          <ReadOnlyInput
            text={`${holiday.specificDates[0][0]}년`}
            style={{ flex: 1, minWidth: 80 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates[0][1]}월`}
            style={{ flex: 1, minWidth: 60 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates[0][2]}일`}
            style={{ flex: 1, minWidth: 60 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][0] : holiday.specificDates[1][0]}년`}
            style={{ flex: 1, minWidth: 80 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][1] : holiday.specificDates[1][1]}월`}
            style={{ flex: 1, minWidth: 60 }}
          />
          <ReadOnlyInput
            text={`${holiday.specificDates.length < 2 ? holiday.specificDates[0][2] : holiday.specificDates[1][2]}일`}
            style={{ flex: 1, minWidth: 60 }}
          />
        </div>
      )
    );
};

const RegularHolidays = (storeHolidayList: Holiday[], isMobile: boolean) => {
  return storeHolidayList
    .filter((v) => v.holidayType !== 'SPECIFIC_DATE' && validateHoliday(v))
    .map((holiday, i) =>
      i === 0 ? (
        <div style={{ display: 'flex', gap: '8px', marginTop: 20 }} key={i}>
          <LabeledReadOnlyInput
            label="휴무일"
            value="휴무일"
            isMobile={isMobile}
            style={{ width: 100 }}
            isColumn={true}
          />
          <LabeledReadOnlyInput
            label="주차"
            value={
              holiday.holidayType === 'MONTHLY_WEEK_AND_DAY'
                ? `매월 ${holiday.weeksOfMonth.map((week) => WEEKS[week]).join(', ')}`
                : '매주'
            }
            isMobile={isMobile}
            style={{ flex: 1, minWidth: 100 }}
            isColumn={true}
          />
          <LabeledReadOnlyInput
            label="요일"
            value={holiday.daysOfWeek.map((day) => DAYS[day]).join(', ')}
            isMobile={isMobile}
            style={{ flex: 1, minWidth: 60 }}
            isColumn={true}
          />
        </div>
      ) : (
        <div style={{ display: 'flex', gap: '8px', marginTop: 4 }} key={i}>
          <ReadOnlyInput text="휴무일" style={{ width: 100 }} />
          <ReadOnlyInput
            text={
              holiday.holidayType === 'MONTHLY_WEEK_AND_DAY'
                ? `매월 ${holiday.weeksOfMonth.map((week) => WEEKS[week]).join(', ')}`
                : '매주'
            }
            style={{ flex: 1, minWidth: 100 }}
          />
          <ReadOnlyInput
            text={holiday.daysOfWeek.map((day) => DAYS[day]).join(', ')}
            style={{ flex: 1, minWidth: 60 }}
          />
        </div>
      )
    );
};

const MonthlyDateHolidays = (storeHolidayList: Holiday[], isMobile: boolean) => {
  return storeHolidayList
    .filter((v) => v.holidayType === 'MONTHLY_DATE' && validateHoliday(v))
    .map((holiday, i) =>
      i === 0 ? (
        <div style={{ display: 'flex', gap: '8px', marginTop: 20 }} key={i}>
          <LabeledReadOnlyInput
            label="휴무일"
            value="휴무일"
            isMobile={isMobile}
            style={{ width: 100 }}
            isColumn={true}
          />
          <LabeledReadOnlyInput
            label="지정일"
            value={`매월 ${holiday.daysOfMonth.map((v) => `${v}일`).join(', ')}`}
            isMobile={isMobile}
            style={{ flex: 1, minWidth: 100 }}
            isColumn={true}
          />
        </div>
      ) : (
        <div style={{ display: 'flex', gap: '8px', marginTop: 4 }} key={i}>
          <ReadOnlyInput text="휴무일" style={{ width: 100 }} />
          <ReadOnlyInput
            text={`매월 ${holiday.daysOfMonth.map((v) => `${v}일`).join(', ')}`}
            style={{ flex: 1, minWidth: 100 }}
          />
        </div>
      )
    );
};
